module.exports = __webpack_public_path__ + "static/media/for-students-first@3x.0668acc6.jpg";